module.exports = __webpack_public_path__ + "static/media/survey-menu.1decff41.png";